import { useTranslation } from "react-i18next";
import type { FieldStatusDto } from "../../../../../../autogen/bff-api";
import { BidSubmissionDeadlineField } from "../BidSubmissionDeadlineField";
import { SummarySection } from "./SummarySection";

interface DeadlinesSectionProps {
  eventId: string;
  currentDeadline: string | null;
  status: FieldStatusDto | undefined;
}

export const DeadlinesSection = ({ eventId, currentDeadline, status }: DeadlinesSectionProps) => {
  const { t } = useTranslation();
  return (
    <SummarySection
      title={t("Deadlines")}
      editTarget={{ kind: "auto-saved" }}
      fieldStatuses={status ? [status] : []}
      variant="editable"
    >
      <BidSubmissionDeadlineField eventId={eventId} currentDeadline={currentDeadline} />
    </SummarySection>
  );
};
